<template>
    <div class="container">
        <h1 class="mt-2 mb-4">Forgot Password</h1>
        <div class="pb-20 h-screen w-full md:w-1/2">
            <div class="mt-6" ref="email">
                <p class="mt-3 mb-10">Enter your email address below and we'll send you a password reset link.</p>
            </div>

            <form method="POST" aria-label="Forgot Password" @submit.prevent="validateBeforeSubmit">
                <div v-bind:class="{'mb-4': true, 'has-error': errors.has('email')}">
                    <label for="email" class="text-h3 font-sans-bold">Email Address</label>
                    <input id="email" type="email" name="email" v-model="form.email" v-validate="'required|email'">
                    <div class="mt-4">
                        <span v-show="errors.has('email')" class="error text-error-red text-lg">{{ errors.first('email') }}</span>
                    </div>
                </div>

                <button type="submit" class="button">
                    Send reset link
                </button>
            </form>
        </div>
  </div>
</template>

<script>
    import _ from "lodash";
    import validation from "../../mixins/validation";

    export default {
        name: "UserForgotPassword",
        title: "Forgot Password",
        mixins: [validation],
        data() {
            return {
                form: {
                    email: null
                }
            };
        },
        computed: {},
        methods: {
            validateBeforeSubmit: function() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.gotoFirstValidationError();
                        return;
                    }

                    axios
                        .post(this.$laroute.route("password.email"), this.form)
                        .then(response => {
                            this.$toasted.show("Reset link sent");
                            this.$router.push("/");
                        })
                        .catch(e => {
                            console.log(e);
                            if (e.response.data.errors) {
                                _.forEach(e.response.data.errors, (message, id) => {
                                    const field = this.$validator.fields.find({
                                        name: id,
                                        scope: this.$options.scope
                                    });
                                    this.$validator.errors.add({
                                        id: field.id,
                                        field: id,
                                        msg: message[0],
                                        scope: this.$options.scope
                                    });
                                });
                            }
                        });
                });
            }
        },
        mounted() {}
    };
</script>
